// Deprecated. Please refrain from new usage
import React from "react";
import PropTypes from "prop-types";
import { withStyles, withTheme } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeaderWithTopRight from "./CardHeaderWithTopRight";
import ActionButtons from "./ActionButtons";
import useMediaQuery from "../../hooks/useMediaQuery";

const style = () => ({
  root: {
    borderRadius: 0,
    height: "100%",
  },
  cardContent: {
    padding: "16px",
    margin: 0,
  },
  baseGrid: {
    margin: 0,
    position: "relative",
  },
});

const FullScreenWidget = ({
  bottomLeft,
  bottomRight,
  buttons,
  theme,
  cardContentStyle,
  cardHeaderProps,
  classes,
  children,
  customHeader,
  loading,
  subheader,
  title,
  topRight,
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid
      item
      xs={12}
      className={classes.baseGrid}
      style={{
        padding: isMobile ? "0 32px" : 10,
      }}
    >
      <Card className={classes.root}>
        {!customHeader && (
          <CardHeaderWithTopRight
            title={title}
            subheader={subheader}
            loading={loading}
            cardHeaderProps={cardHeaderProps}
          >
            {topRight}
          </CardHeaderWithTopRight>
        )}
        {!!customHeader && customHeader}
        <CardContent
          className={classes.cardContent}
          style={{
            ...cardContentStyle,
          }}
        >
          {children}
        </CardContent>
        {(bottomLeft || bottomRight || buttons.length !== 0) && (
          <ActionButtons buttons={buttons} bottomLeft={bottomLeft} bottomRight={bottomRight} />
        )}
      </Card>
    </Grid>
  );
};

FullScreenWidget.propTypes = {
  title: PropTypes.string.isRequired,
  subheader: PropTypes.node,
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  customHeader: PropTypes.node,
  cardContentStyle: PropTypes.object,
  cardHeaderProps: PropTypes.object,
  buttons: PropTypes.array,
  topRight: PropTypes.node,
  children: PropTypes.node,
  bottomLeft: PropTypes.node,
  bottomRight: PropTypes.node,
  loading: PropTypes.bool,
};

FullScreenWidget.defaultProps = {
  customHeader: null,
  cardContentStyle: null,
  cardHeaderProps: null,
  topRight: <div />,
  children: null,
  bottomLeft: null,
  bottomRight: null,
  buttons: [],
  loading: false,
  subheader: null,
};

export default withTranslation("common")(withStyles(style)(withTheme(FullScreenWidget)));
export { FullScreenWidget };
